require("!!/home/node/proj/node_modules/script-loader/addScript.js")(require("!!/home/node/proj/node_modules/raw-loader/index.js!/home/node/proj/node_modules/zepto/dist/zepto.min.js"))

/*** EXPORTS FROM exports-loader ***/
module.exports = window.$;


//////////////////
// WEBPACK FOOTER
// ./~/zepto/dist/zepto.min.js
// module id = 1
// module chunks = 0 204 209